import { render, staticRenderFns } from "./bankruptcyManagerInfo.vue?vue&type=template&id=f93e6278&scoped=true&"
import script from "./bankruptcyManagerInfo.vue?vue&type=script&lang=js&"
export * from "./bankruptcyManagerInfo.vue?vue&type=script&lang=js&"
import style0 from "./bankruptcyManagerInfo.vue?vue&type=style&index=0&id=f93e6278&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f93e6278",
  null
  
)

export default component.exports